import React, { useState,useEffect } from 'react'
import { useAuth } from '../../context/Auth'
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import App from './Spinner';


const Admin = () => {
    const [ok,setOk]=useState(false);
    const [auth,setAuth]=useAuth();
    
    useEffect(() => {
        const authCheck = async () => {
            const res = await axios.get("https://busy-pink-chinchilla-suit.cyclic.app/api/admin-auth", {
                headers: {
                    Authorization: auth?.token
                }
            });
            (res.data.ok) ? setOk(true) : setOk(false);
        }
        if (auth?.token) {
            authCheck();
        }
    }, [auth?.token]);

  return (
     ok ? <Outlet/> : <App path='/'/>
  )
}

export default Admin